// Words Peterson also pronounces another way than the regular rules give ("also pronounced" rows):
// borrowings that may keep their own stress (pt-g0062) and words with an alternate pronunciation of
// their own (daor, gr-g-0115). Data only; the logic is in engine/src/borrowed-stress.ts, shown
// beside the regular stress by the app's StressWord.
//
// Peterson (dothraki.com 2013-04-22, "Sesīr urnēbion zȳhon keliton issa"): borrowings go into the
// borrowed (sixth) declension and may keep non-HV stress: buzdari stressed on the 2nd syllable.
// Decided by Axel in the review session of 2026-10-06 (docs/TRANSLATOR-PHASE4.md "Decisions for the
// users" 12): the regular stress stays the main one (BUZ·da·ri, the rules every learner uses), and
// the borrowed one is shown beside it ("myös buz·DA·ri (lainasana, Peterson)"). Only the forms he
// named are listed; other forms of the word keep the regular stress alone.
//
// daor (build-039, review 2026-10-07, approved by Axel): one syllable by the spelling, but Peterson
// "often says [da.ˈoːr] or [da.or]" (dothraki.com 2013-05 comment, gr-g-0115), and the wiki's Daor
// § Etymology gives the alternate /daˈoːr/: two vowels with word-final stress (from the obsolete
// stem *davūr-). Shown as "myös da·OR (Peterson)" beside the regular DAOR; its own syllable split.
// Follow-up approved by Axel 2026-10-08: da·OR is the main display (the wiki's Daor entry: "most
// often … two separate monophthongs"; Peterson's comment 1792), the one-syllable DAOR (by the
// spelling) is shown beside it ("myös DAOR (kirjoitusasun mukaan)"): `main`.

export interface BorrowedStress {
  /** the word form, lowercase NFC */
  word: string;
  /** index of the stressed syllable (0 = first) in the other pronunciation */
  stressed: number;
  /**
   * Its own syllable split, when it differs from the regular one (daor: da·or, two vowels instead
   * of a diphthong). Lowercase; the syllables spell the word exactly. Absent: the regular split.
   */
  syllables?: readonly string[];
  /** Why it is said so: a borrowing keeping its stress, or Peterson's alternate pronunciation. */
  kind?: 'borrowing' | 'alternate';
  /**
   * The other pronunciation is the main display, and the regular one is shown beside it (daor: the
   * wiki says it is most often two syllables). Absent: the regular stress stays the main one.
   */
  main?: boolean;
  claims: string[];
  source: string;
}

export const BORROWED_STRESS: readonly BorrowedStress[] = [
  {
    word: 'buzdari',
    stressed: 1,
    kind: 'borrowing',
    claims: ['pt-g0062'],
    source: 'Peterson, dothraki.com 2013-04-22: "buzdari" may keep its non-HV stress, on the 2nd syllable.',
  },
  {
    word: 'daor',
    stressed: 1,
    syllables: ['da', 'or'],
    kind: 'alternate',
    main: true,
    claims: ['gr-g-0115'],
    source:
      'Peterson, dothraki.com 2013-05 (comment 1792): he often says [da.ˈoːr] or [da.or]; wiki Daor § Etymology: alternate /daˈoːr/, "most often" two separate monophthongs with word-final stress.',
  },
];
